export default {
    "it-IT": {
        aPartireDaXInYRate: "A partire da <strong>{X}</strong> in {Y} rate",
        simulazionePerXRateInCorso:
            "Simulazione per <strong>{X} rate</strong> in corso.",
        acquistabileInXRate: "Acquistabile in <strong>{X}</strong> rate",
        inQuanteRateVuoiPagare: "In quante rate vuoi pagare?",
        rateSelezionate: "Rate selezionate",
        effetuaSimulazione: "Effettua simulazione",
        prospettoFinanziamento: "Prospetto finanziamento",
        rataDa: "Rata da",
    },
    "fr-FR": {
        aPartireDaXInYRate:
            "À partir de: <strong>{X}</strong> par {Y} versements",
        simulazionePerXRateInCorso:
            "Simulation pour <strong>{X} versements</strong> en cours.",
        acquistabileInXRate: "Disponible en <strong>{X}</strong> versements",
        inQuanteRateVuoiPagare:
            "En combien de versements souhaitez-vous régler?",
        rateSelezionate: "Versements sélectionnés",
        effetuaSimulazione: "Effectuez une simulation",
        prospettoFinanziamento: "Résultat de la simulation",
        rataDa: "Versement de",
    },
    "es-ES": {
        aPartireDaXInYRate: "Desde: {X} en {Y} cuotas",
        simulazionePerXRateInCorso: "Simulación para {X} cuotas en curso.",
        acquistabileInXRate: "A pagar en {X} cuotas",
        inQuanteRateVuoiPagare: "¿En cuántas cuotas quieres pagar?",
        rateSelezionate: "Cuotas seleccionadas",
        effetuaSimulazione: "Realiza una simulación",
        prospettoFinanziamento: "Folleto de financiación",
        rataDa: "Cuota desde",
    },
    "en-GB": {
        aPartireDaXInYRate:
            "Starting from: <strong>{X}</strong> in {Y} monthly instalments",
        simulazionePerXRateInCorso:
            "Simulation for <strong>{X}</strong> instalments in progress.",
        acquistabileInXRate: "Purchasable in <strong>{X}</strong> instalments",
        inQuanteRateVuoiPagare: "How many instalments would you like to pay?",
        rateSelezionate: "Instalments selected",
        effetuaSimulazione: "Simulate",
        prospettoFinanziamento: "Financing overview",
        rataDa: "Instalments from",
    },
    "en-US": {
        aPartireDaXInYRate:
            "Starting from: <strong>{X}</strong> in {Y} monthly instalments",
        simulazionePerXRateInCorso:
            "Simulation for <strong>{X}</strong> instalments in progress.",
        acquistabileInXRate: "Purchasable in <strong>{X}</strong> instalments",
        inQuanteRateVuoiPagare: "How many instalments would you like to pay?",
        rateSelezionate: "Instalments selected",
        effetuaSimulazione: "Simulate",
        prospettoFinanziamento: "Financing overview",
        rataDa: "Instalments from",
    },
    "de-DE": {
        aPartireDaXInYRate: "Ab: <strong>{X}</strong> in {Y} Raten",
        simulazionePerXRateInCorso:
            "Simulation für <strong>{X} Raten</strong> in Bearbeitung.",
        acquistabileInXRate: "Verfügbar in <strong>{X}</strong> Raten",
        inQuanteRateVuoiPagare: "In wie vielen Raten wollen Sie zahlen?",
        rateSelezionate: "Ausgewählte Raten",
        effetuaSimulazione: "Simulation durchführen",
        prospettoFinanziamento: "Finanzierungsübersicht",
        rataDa: "Raten von",
    },
    "en-AU": {
        aPartireDaXInYRate:
            "Starting from: <strong>{X}</strong> in {Y} monthly instalments",
        simulazionePerXRateInCorso:
            "Simulation for <strong>{X}</strong> instalments in progress.",
        acquistabileInXRate: "Purchasable in <strong>{X}</strong> instalments",
        inQuanteRateVuoiPagare: "How many instalments would you like to pay?",
        rateSelezionate: "Instalments selected",
        effetuaSimulazione: "Simulate",
        prospettoFinanziamento: "Financing overview",
        rataDa: "Instalments from",
    },
    "ko-KR": {
        aPartireDaXInYRate: "",
        simulazionePerXRateInCorso: "",
        acquistabileInXRate: "",
        inQuanteRateVuoiPagare: "In quante rate vuoi pagare?",
        rateSelezionate: "",
        effetuaSimulazione: "",
        prospettoFinanziamento: "",
        rataDa: "",
    },
    "ja-JP": {
        aPartireDaXInYRate: "<strong>{X}</strong>より（{Y}回の分割払い）",
        simulazionePerXRateInCorso:
            "<strong>{X}回</strong>のお支払いのシミュレーションを実行中です。",
        acquistabileInXRate:
            "<strong>{X}回</strong>のお支払でご購入いただけます。",
        inQuanteRateVuoiPagare: "何回でお支払いされたいですか？",
        rateSelezionate: "回数が選択されました。",
        effetuaSimulazione: "シミュレーションを実行する。",
        prospettoFinanziamento: "融資の概要",
        rataDa: "一回分のお支払い金額は",
    },
};
